<div class="flex flex-col items-center justify-center min-h-screen container-padding">
  <div class="w-full max-w-md bg-[var(--white)] border-4 border-[var(--tertiary)] rounded-2xl p-8 text-center shadow">

    <ng-container *ngIf="isLoading">
      <p class="text-[var(--dark-orange)] font-bold uppercase">Procesando autenticación...</p>
    </ng-container>

    <ng-container *ngIf="!isLoading && message">
      <p class="text-[var(--dark-orange)] font-bold text-lg">{{ message }}</p>
    </ng-container>

  </div>
</div>
